module.exports = __webpack_public_path__ + "static/3-73e6f893ee98bd932b4f5f4d13fd36b9.png";